(() => {
  const guard = '__sokamejaStatCounterInitialized';
  const scriptId = 'sokameja-statcounter';
  let shopifyLoaderAttempts = 0;

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (_error) {
      return false;
    }
  };

  const loadStatCounter = () => {
    if (window[guard] || !analyticsAllowed()) return;

    window[guard] = true;
    window.sc_project = 6418579;
    window.sc_invisible = 1;
    window.sc_security = '919643b0';

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://www.statcounter.com/counter/counter.js';
    script.async = true;
    document.head.appendChild(script);
  };

  const loadCustomerPrivacy = () => {
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (!error) loadStatCounter();
        }
      );
      return;
    }
    shopifyLoaderAttempts += 1;
    if (shopifyLoaderAttempts < 100) window.setTimeout(loadCustomerPrivacy, 50);
  };

  document.addEventListener('visitorConsentCollected', loadStatCounter);
  loadCustomerPrivacy();
})();
